<template>
    <div class="row">
        <div class="span8">
            <label><strong>{{ label }}:</strong></label>
            <input type="text" v-model="text2" class="input-xxlarge" />            
        </div>
    </div>
</template>

<script>
    export default {
        name: 'block-title',
        props: {            
            label: {
                type: String,
                required: true
            },
            index: {
                type: Number,
                required: true
            },
            text: {
                type: String,
                required: true
            }
        },
        data() {
            return {
                text2: this.text                
            }
        },        
        watch: {
            text2() { 
                var self = this;
                self.$emit('update:text', self.text2);  
            }
        },
        methods: {
        }
    }
</script>



// WEBPACK FOOTER //
// _block-text.vue?72e784f6